"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGION_OPTIONS = void 0;

var _region = require("./region");

var REGION_OPTIONS = [{
  label: 'Asia',
  value: _region.REGION.ASIA
}, {
  label: 'Australia',
  value: _region.REGION.AUSTRALIA
}, {
  label: 'EU',
  value: _region.REGION.EU
}, {
  label: 'US',
  value: _region.REGION.US
}];
exports.REGION_OPTIONS = REGION_OPTIONS;